var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "notification-panel" }, [
    _c(
      "div",
      { staticClass: "email-settings-wrapper" },
      [
        _c("h2", { staticClass: "panel-title" }, [
          _vm._v("Email Notifications"),
        ]),
        _vm._v(" "),
        _c("rt-select", {
          staticClass: "email-select",
          attrs: {
            type: "floating",
            floatLabel: "Preferred email",
            options: _vm.emailList,
            value: "0",
            disabled: true,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "notification-settings-wrapper" }, [
      _c("h3", { staticClass: "settings-title" }, [
        _vm._v("Send me email notifications for:"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "notification-wrapper" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("rt-switch", {
            staticClass: "notification-switch",
            attrs: { value: _vm.activityUpdateOn },
            on: {
              input: function ($event) {
                _vm.activityUpdateOn = $event
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "notification-wrapper" },
        [
          _vm._m(1),
          _vm._v(" "),
          _c("rt-switch", {
            staticClass: "notification-switch",
            attrs: { value: _vm.dailySummaryOn },
            on: {
              input: function ($event) {
                _vm.dailySummaryOn = $event
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "notification-wrapper" },
        [
          _vm._m(2),
          _vm._v(" "),
          _c("rt-switch", {
            staticClass: "notification-switch",
            attrs: { value: _vm.weeklyReportOn },
            on: {
              input: function ($event) {
                _vm.weeklyReportOn = $event
              },
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "setting-panel-footer" },
      [
        _c(
          "primary-button",
          {
            staticClass: "btn-close",
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          },
          [_vm._v("Close")]
        ),
        _vm._v(" "),
        _c(
          "primary-button",
          {
            staticClass: "btn-save",
            on: { click: _vm.handleSaveNotification },
          },
          [_vm._v("Save")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "notification-setting" }, [
      _c("h3", { staticClass: "settings-title" }, [_vm._v("Activity updates")]),
      _vm._v(" "),
      _c("p", { staticClass: "notification-description" }, [
        _vm._v(
          "New tasks assigned to you, and completion notifications for tasks you're a collaborator on"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "notification-setting" }, [
      _c("h3", { staticClass: "settings-title" }, [_vm._v("Daily summaries")]),
      _vm._v(" "),
      _c("p", { staticClass: "notification-description" }, [
        _vm._v("New tasks assigned to you and upcoming due dates"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "notification-setting" }, [
      _c("h3", { staticClass: "settings-title" }, [_vm._v("Weekly reports")]),
      _vm._v(" "),
      _c("p", { staticClass: "notification-description" }, [
        _vm._v("Status updates on projects in your portfolios"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }